import React from 'react';
import Drawer from 'material-ui/Drawer';
import Menu from './Menu'

export default class AppDrawer extends React.Component {
    componentDidMount() {
      let frameCount = 0;
      const open = () => (frameCount++ > 0) ? this.props.onMounted() :
        requestAnimationFrame(open);
      requestAnimationFrame(open);
    }
    render() {
      return (
        <div>
          <Drawer
            docked={false}
            width={200}
            open={this.props.open}
            onRequestChange={this.props.onRequestChange}
            containerStyle={{ backgroundColor: '#37424b' }}
          >
            <Menu onClick={this.props.onClick} />
          </Drawer>
        </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/template/AppDrawer.js